import React from 'react';
import {useTranslation} from 'react-i18next';
import {UseFormReturn} from 'react-hook-form';
import {IFetchRoom} from '../../../../../incase-domain/rooms/room.editor';
import ProtectionForm from '../../../../../components/presentation/settings/ProtectionForm';

interface EditRoomAccessTabProps {
    room: IFetchRoom | undefined;
    useForm: UseFormReturn;
}

function EditRoomAccessTab({room, useForm}: EditRoomAccessTabProps): JSX.Element {
    const {t} = useTranslation();

    const {formState, watch, setValue} = useForm;
    const {errors} = formState;

    const protection = watch('protection');

    const defaultList = room?.protection?.allowedUsers?.map((user) => ({value: user._id, label: user.email})) || [];

    return (
        <div>
            <div className="c-editRoomModal__content_header">{t('roomsPage.modals.roomAccess')}</div>
            <ProtectionForm
                protection={protection}
                setProtection={(value) => setValue('protection', value)}
                errors={errors}
                selectedAccounts={defaultList}
            />
        </div>
    );
}

export default EditRoomAccessTab;
